import { graphql } from "~/gql";

export const CREATED_OR_UPDATED_MATTER = graphql(/* GraphQL */ `
  subscription CreatedOrUpdatedMatter {
    createdOrUpdatedMatter {
      __typename
      id
      title
      status
      reference
      createdAt
      updatedAt
      template
      parentMatterId
      parent {
        id
        title
        matters {
          id
          title
        }
      }
      externalMatterId
      externalMatter {
        id
        title
        status
        leadFeeEarner {
          id
          name
        }
        client {
          id
          name
          externalReference
          type
        }
        externalReference
        organisationalUnit {
          __typename
          id
          name
          parent {
            id
            name
          }
        }
      }
      externalReference
      createdBy {
        id
        userName
        displayName
      }
      client {
        id
        name
        externalReference
        type
      }
      priceOptions {
        estimatedGpm
        estimatedSuggested
        estimatedChosen
        estimatedRangeGpm
        estimatedRangeSuggestedLower
        estimatedRangeSuggestedUpper
        estimatedRangeChosenLower
        estimatedRangeChosenUpper
        fixedGpm
        fixedSuggested
        fixedChosen
        cappedChosen
        cappedGpm
        cappedSuggested
      }
      disbursements {
        __typename
        autoFocus @client
        id
        name
        amount
        vatStatus
        order
      }
      uplifts {
        __typename
        autoFocus @client
        id
        amount
        type
        order
        baseUplift {
          id
          reason
        }
      }
      discounts {
        __typename
        autoFocus @client
        id
        reason
        amount
        type
        order
      }
      phases {
        __typename
        autoFocus @client
        id
        title
        description
        order
        priceOptions {
          estimatedGpm
          estimatedSuggested
          estimatedChosen
          estimatedRangeGpm
          estimatedRangeSuggestedLower
          estimatedRangeSuggestedUpper
          estimatedRangeChosenLower
          estimatedRangeChosenUpper
          fixedGpm
          fixedSuggested
          fixedChosen
          cappedChosen
          cappedGpm
          cappedSuggested
        }
        __typename
        id
        title
        order
        work {
          __typename
          id
          phaseId
          timeLower
          timeUpper
          timeSingle
          price {
            lower
            upper
            single
          }
          selectedRate {
            id
            description
            amount
            clientId
            feeEarnerId
            feeEarnerLevelId
          }
          feeEarnerLevel {
            id
            description
            order
          }
          feeEarner {
            id
            name
            feeEarnerLevel {
              id
              description
              order
            }
            rates {
              id
              description
              amount
              clientId
              feeEarnerId
              feeEarnerLevelId
            }
            practiceArea {
              id
              name
            }
          }
          cost {
            lower
            upper
            single
          }
          price {
            lower
            upper
            single
          }
        }
      }
      organisationalUnit {
        __typename
        id
        name
        parent {
          id
          name
        }
      }
      leadFeeEarner {
        __typename
        id
        name
        feeEarnerLevel {
          id
        }
      }
      pricingType
      pricingLevel
      taxStatus
      includeTasksInProposalOutput
      includeRatesInProposalOutput
      disbursements {
        ...DisbursementParts
      }
      brand {
        ...BrandParts
      }
    }
  }
`);
